import { getCookie } from 'cookies-next'
import { v4 as uuidv4 } from 'uuid'

import { IS_TEST_ENV } from '@/config/constants'
import { DEFAULT_LOCALE, isValidLocale } from '@/lib/config/i18n/local'
import { getToken } from '@/lib/utils/auth'
import { getDeviceId } from '@/lib/utils/device-id'

export const PROD_API_BASE_URL = 'https://api.digen.ai'

/** 获取 API 基础 URL */
export function getBaseURL(): string {
  if (IS_TEST_ENV) {
    return 'https://test.api.digen.ai'
  }
  return PROD_API_BASE_URL
}

/** 获取当前语言 */
export function getCurrentLanguage(): string {
  const userLanguage = getCookie('NEXT_LOCALE')?.toString()
  if (userLanguage && isValidLocale(userLanguage)) {
    return userLanguage
  }

  if (typeof window !== 'undefined') {
    const pathSegments = window.location.pathname.split('/')
    const localeFromPath = pathSegments[1]
    if (localeFromPath && isValidLocale(localeFromPath)) {
      return localeFromPath
    }
  }

  return DEFAULT_LOCALE
}

/** 获取 Digen-Token */
export function getDigenToken(): string | null {
  return getToken()
}

/** 获取自定义请求头 */
export function getCustomHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Digen-Language': getCurrentLanguage(),
    'Digen-SessionID': uuidv4()
  }

  const token = getDigenToken()
  if (token) {
    headers['Digen-Token'] = token
  }

  const deviceId = getDeviceId()
  if (deviceId) {
    headers['Digen-DeviceID'] = deviceId
  }

  return headers
}